import React, { Component } from 'react'
import Navbar from './Navbar';

export default class TwelveColors extends Component {
    render() {
        return (
            <div className="make-test">
        <Navbar />

        <div className="container">
          <div className="row p-5 text-center">
            <div className="col">
              <img
                src={"dragonfly.png"}
                className="card-img-top w-25"
                alt="The Healing Colors"
              ></img>
              <h2 className="text-light mt-3">The 12 Colors</h2>
              {/* <h5 className="text-light mt-3">Familiarize with the colors, take your time...</h5> */}
            </div>             
          </div>
          <div className="row text-center">
            <div className="col-4 col-md-2">
            <span className="dot purple"></span>
              <p className="text-light">
                Purple
              </p>              
            </div>

            <div className="col-4 col-md-2">   
            <span className="dot magenta"></span>           
              <p className="text-light">
                Magenta
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot scarlet"></span>
              <p className="text-light">
                Scarlet
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot red"></span>
              <p className="text-light">
                Red
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot orange"></span>
              <p className="text-light">
                Orange
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot yellow"></span>
              <p className="text-light">
                Yellow
              </p>              
            </div>            
          </div>

          <div className="row text-center">
            <div className="col-4 col-md-2">
            <span className="dot lemon"></span>
              <p className="text-light">
                Lemon
              </p>              
            </div>

            <div className="col-4 col-md-2">   
            <span className="dot green"></span>           
              <p className="text-light">
                Green
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot turquoise"></span>
              <p className="text-light">
                Turquoise
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot cyan"></span>
              <p className="text-light">
                Cyan
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot indigo"></span>
              <p className="text-light">
                Indigo
              </p>              
            </div>

            <div className="col-4 col-md-2">              
            <span className="dot blue"></span>
              <p className="text-light">
                Blue
              </p>              
            </div>            
          </div>
        </div>
      </div>
        )
    }
}
